import React, { useState } from "react";
import { CheckCircle2, ChevronDown, XCircle } from "lucide-react";
import { MarkdownMessage } from "@/components/MarkdownMessage";

const CHECKS = [
  ["sources", "Fuentes de su KBL"],
  ["facts", "Datos clave"],
  ["review", "Revisión IA"],
];

const Chip = ({ ok, label }) => (
  <span
    className={`inline-flex items-center gap-1 border px-2 py-0.5 text-[10px] uppercase tracking-[0.12em] ${
      ok ? "border-emerald-600/40 bg-emerald-50 text-emerald-800" : "border-red-500/40 bg-red-50 text-red-700"
    }`}
  >
    {ok ? <CheckCircle2 className="h-3 w-3" /> : <XCircle className="h-3 w-3" />} {label}
  </span>
);

export const QaResultCard = ({ r, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <li className="border border-slate-200 bg-white p-5" data-testid={`qa-result-${index}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <p className="max-w-3xl text-sm font-medium text-slate-900">
          <span className="mr-2 font-mono text-xs text-slate-400">P{String(index + 1).padStart(2, "0")}</span>
          {r.question}
        </p>
        <span
          className={`px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.16em] ${r.passed ? "bg-emerald-600 text-white" : "bg-red-600 text-white"}`}
          data-testid={`qa-result-status-${index}`}
        >
          {r.passed ? "Aprobada" : "Reprobada"}
        </span>
      </div>
      {r.error ? (
        <p className="mt-3 text-sm text-red-700">{r.error}</p>
      ) : (
        <>
          <div className="mt-3 flex flex-wrap gap-2">
            {CHECKS.map(([k, label]) => <Chip key={k} ok={r.checks?.[k]} label={label} />)}
          </div>
          <dl className="mt-4 grid gap-3 text-xs text-slate-600 md:grid-cols-3">
            <div>
              <dt className="text-[10px] uppercase tracking-[0.16em] text-slate-400">Datos encontrados</dt>
              <dd className="mt-1">
                {r.expected_facts.map((f) => (
                  <span key={f} className={`mr-2 ${r.facts_found.includes(f) ? "text-emerald-700" : "text-red-600 line-through"}`}>{f}</span>
                ))}
              </dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.16em] text-slate-400">Documentos citados</dt>
              <dd className="mt-1">{r.cited_docs.join(" · ") || "Ninguno"}</dd>
            </div>
            <div>
              <dt className="text-[10px] uppercase tracking-[0.16em] text-slate-400">Modelo que respondió</dt>
              <dd className="mt-1 font-mono">{r.llm?.provider} · {r.llm?.model}</dd>
            </div>
          </dl>
          <p className="mt-3 border-l-2 border-accent-blue bg-slate-50 px-3 py-2 text-xs text-slate-700" data-testid={`qa-result-review-${index}`}>
            {r.review?.explanation}
          </p>
          <button
            onClick={() => setOpen((o) => !o)}
            className="mt-3 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.16em] text-accent-blue"
            data-testid={`qa-result-toggle-${index}`}
          >
            <ChevronDown className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`} />
            {open ? "Ocultar respuesta" : "Ver respuesta del agente"}
          </button>
          {open && (
            <div className="mt-2 bg-slate-950 p-4 text-sm leading-relaxed text-slate-200" data-testid={`qa-result-answer-${index}`}>
              <MarkdownMessage>{r.answer}</MarkdownMessage>
            </div>
          )}
        </>
      )}
    </li>
  );
};
